import { render, staticRenderFns } from "./SavePresetModal.vue?vue&type=template&id=38a54568"
import script from "./SavePresetModal.vue?vue&type=script&lang=js"
export * from "./SavePresetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports